import {
  CSS_CLASSES,
  ELEMENT_SELECTORS,
  ONE_HOUR_MS,
  ONE_MINUTE_MS,
  ONE_SECOND_MS,
  TIMER_OFFSET_SEC
} from './constants.js'

export function handleFinishButtonClick (button: HTMLButtonElement, form: HTMLFormElement) {
  let clickCount = 1
  button.addEventListener('click', (e) => {
    if (clickCount !== 1 || !form) {
      e.preventDefault()
      return
    }
    if (form.checkValidity()) {
      button.innerText = CSS_CLASSES.sending
      clickCount++
    } else {
      form.reportValidity()
    }
  })
}

let requiredBillFields: NodeListOf<HTMLInputElement>

function fetchRequiredBillFields (addressDiv: HTMLDivElement): void {
  requiredBillFields = addressDiv.querySelectorAll<HTMLInputElement>('[required="required"]')
}

function addRequiredBillFields (): void {
  if (!requiredBillFields) return

  requiredBillFields.forEach(element => {
    element.required = true
  })
}

function removeRequiredBillFields (): void {
  if (!requiredBillFields) return

  requiredBillFields.forEach(element => {
    element.required = false
  })
}

export function handleBillAddressToggle (button: HTMLInputElement, addressDiv: HTMLDivElement) {
  fetchRequiredBillFields(addressDiv)

  if (addressDiv.classList.contains(CSS_CLASSES.hidden)) {
    removeRequiredBillFields()
  }

  button.addEventListener('change', () => {
    if (button.checked) {
      addressDiv.classList.remove(CSS_CLASSES.hidden)
      addressDiv.classList.add(CSS_CLASSES.grid)
      addRequiredBillFields()
    } else {
      addressDiv.classList.add(CSS_CLASSES.hidden)
      addressDiv.classList.remove(CSS_CLASSES.grid)
      removeRequiredBillFields()
    }
  })
}

export function handlePasswordToggle (eye: SVGElement) {
  const passwordInput = document.querySelector<HTMLInputElement>(ELEMENT_SELECTORS.passwordInput)
  eye.addEventListener('click', () => {
    if (passwordInput) {
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
    }
  })
}

function getRemainingTime (endTime: number) {
  const now = new Date().getTime()
  return endTime - now
}

function formatTime (distance: number) {
  const minutes = Math.floor((distance % ONE_HOUR_MS) / ONE_MINUTE_MS)
  const seconds = Math.floor((distance % ONE_MINUTE_MS) / ONE_SECOND_MS)
  return `${minutes}m ${seconds}s`
}

function hideElement (element: HTMLElement | null) {
  if (element) {
    element.style.display = 'none'
  }
}

export function startTimer (timer: HTMLSpanElement) {
  const initialTimeMs = (parseInt(timer.dataset.time ?? '0') + TIMER_OFFSET_SEC) * ONE_SECOND_MS
  const countDownEndTime = new Date(initialTimeMs).getTime()
  const intervalId = setInterval(() => {
    const timeRemaining = getRemainingTime(countDownEndTime)
    timer.innerText = formatTime(timeRemaining)
    if (timeRemaining < 0) {
      clearInterval(intervalId)
      hideElement(timer.parentElement?.parentElement || null)
    }
  })
}